import React, { useCallback } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Colors } from '../../../ui';
import { useResolve } from '../../Container';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { UIField, UIFieldProps } from '../../canvas/entities/UIField';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { SimpleTextFieldInput } from '../../canvas/workspace/adapters/SimpleTextFieldInput';
import { Frame } from './Frame';
import { FrameLabelFontSizeAttr } from './FrameAssociations';

export const FrameTitleFieldTextSettings = (frame: Frame) => {
    const fontSize = FrameLabelFontSizeAttr.get(frame);
    return TextSettings.from({
        fontFamily: 'Rubik',
        fontColor: Colors.textLight,
        fontWeight: 400,
        fontSize,
        lineHeight: 1,
        textMargin: [0, 0, 0, fontSize * 1.25],
        fontStyle: 'normal',
        maxFontSize: null,
        textAlignH: TextAlignment.start,
        textAlignV: TextAlignment.start,
    });
};

export const FrameTitleFieldEditor = ({ active, field }: UIFieldProps) => {

    const objects = useResolve(ObjectManager);
    const dispatch = useResolve(CommandDispatcher);
    const frame = field.owner.cast(Frame);
    useComponentObserver(frame);

    const onChange = useCallback((nextValue: string) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            frame.title = nextValue;
        });
    }, [field]);

    const onCommit = useCallback(() => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            u.noop();
        });
    }, []);

    return <SimpleTextFieldInput {...{
        active,
        field,
        settings: FrameTitleFieldTextSettings(frame),
        value: frame.title,
        onChange,
        onCommit,
    }} />;
};

export const FrameTitleField = (owner: Frame): UIField => ({
    ui: FrameTitleFieldEditor,
    name: 'title',
    bounds: owner.layout.title,
    owner,
});


// export class FrameLabel extends SimpleTextField {

//     public readonly fontFamily = 'Rubik';
//     public readonly fontColor = Colors.textLight;
//     public readonly fontWeight = 400;
//     // public readonly lineHeight = 1;
//     // public readonly textAlignV = TextAlignment.middle;

//     constructor() {
//         super();
//         Object.defineProperty(this, 'fontSize', {
//             get: () => FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .6,
//         });
//         Object.defineProperty(this, 'lineHeight', {
//             get: () => {
//                 const a = FrameLabelFontSizeAttr.get(this.owner.cast(Frame));
//                 const b = FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .6;
//                 return a / b;
//             },
//         });
//         Object.defineProperty(this, 'textMargin', {
//             get: () => [0, 1],
//             // get: () => [0, FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .2],
//         });
//     }

//     public get default() {
//         return true;
//     }

//     public get layout(): FieldLayout {
//         return new FieldLayout(this.owner.cast(Frame).layout.label, 1);
//     }
// }
